import http from "./http_common";

class LabService {
  queryString(payload) {
    return Object.keys(payload)
      .map((key) => key + "=" + payload[key])
      .join("&");
  }

  getLabReportData(payload) {
    var queryString = this.queryString(payload);
    return http.get(`labTestOrderResult/getall-labresults?${queryString}`);
  }

  labTests(test) {
    return http.get(
      `/LabTestsAndScans/list/filter?name=${test}&pageNo=${1}&pageSize=${40}`,
    );
  }
  LabTestMdm(payload) {
    payload.labCode = "DZA4401049";
    var queryString = this.queryString(payload);
    return http.get(`/LabInfoMdm/list/filter?${queryString}`);
  }
}

export default new LabService();
